import BuildIcon from '@mui/icons-material/Build'

export const WorkorderIcon = BuildIcon
export default WorkorderIcon
